import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { IdleWarningDialogComponent } from './idle-warning-dialog.component';

@NgModule({
  declarations: [IdleWarningDialogComponent],
  imports: [MatButtonModule, MatIconModule, CommonModule, TranslocoModule],
})
export class IdleWarningDialogModule {}
